<template>
  <div v-if="employees">
    <h2>Employees</h2>
    <div class="description">Manage CanEd employees data</div>

    <div class="table">
      <div class="trow">
        <div class="thead name">Employee Name</div>
        <div class="thead email">e-Mail</div>
        <div class="thead phone-number">Phone Number</div>
        <div class="thead actions">Actions</div>
      </div>
      <div class="trow" v-for="employee in employees" :key="employee.id">
        <div class="tdata name">{{employee.name}}</div>
        <div class="tdata email">{{employee.email}}</div>
        <div class="tdata phone-number">{{employee.phone_number}}</div>
        <div class="tdata actions">
          <router-link :to="`/admin/edit-employee/${employee.id}`">
            <v-button type="primary">Edit</v-button>
          </router-link>
          <!-- <router-link :to="`/admin/emp-reset-password/${employee.id}`">
            <v-button type="primary">Reset Password</v-button>
          </router-link> -->
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'EmployeesView',
  computed: {
    ...mapGetters([
      'employees'
    ])
  },
  watch: {
    employees: {
      handler (val) {
        if (!val) {
          this.$store.dispatch('getEmployees')
        }
      },
      immediate: true
    }
  }
}
</script>

<style scoped>
h2 {
  margin-bottom: 8px;
}
.description {
  margin-bottom: 24px;
}
.table {
  width: 100%;
}
.table .trow {
  display: flex;
  flex-direction: row;
}
.table .thead {
  font-size: 15px;
  padding: 7px 6px;
  background-color: #404040;
  color: ivory;
  border: 1px solid rgba(255, 255, 240, .2);
}
.table .thead:first-child {
  border-top-left-radius: 2px;
}
.table .thead:last-child {
  border-top-right-radius: 2px;
}
.table .tdata {
  font-size: 13px;
  padding: 5px 6px;
  border: 1px solid rgba(131, 127, 127, 0.137);
}
.trow .name {
  width: 30%;
}
.trow .email {
  width: 25%;
}
.trow .phone-number {
  width: 25%;
}
.trow .actions {
  width: 20%;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/views/Admin/Employees/EmployeesView.vue